// "On this day" matcher — finds history entries from N months/years ago.
const RANGES = [
    { key: "1m", label: "a month ago today",   monthsAgo: 1  },
    { key: "3m", label: "three months ago",     monthsAgo: 3  },
    { key: "6m", label: "six months ago",       monthsAgo: 6  },
    { key: "1y", label: "a year ago today",     monthsAgo: 12 },
];

function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();
}

function subMonths(date, m) {
    const d = new Date(date);
    d.setMonth(d.getMonth() - m);
    return d;
}

/**
 * Given a history array (most-recent-first), return the first item that matches
 * "today minus N months" for any N in RANGES. Returns {item, label} or null.
 */
export function findOnThisDay(history) {
    if (!Array.isArray(history) || history.length === 0) return null;
    const today = new Date();
    for (const range of RANGES) {
        const target = subMonths(today, range.monthsAgo);
        const match = history.find((m) => {
            if (!m.created_at) return false;
            const d = new Date(m.created_at);
            return sameDay(d, target);
        });
        if (match) return { item: match, label: range.label, key: range.key };
    }
    return null;
}
